import { ListPayloadCreator } from '../../types';
import dispatchListItemsNextAction from '../misc/dispatchListItemsNextAction';
import fetchParams from '../misc/fetchParams';

const payloadCreatorMyListWithFetch: ListPayloadCreator =
  (idName, api, slice, sliver, nextAction) =>
  async (_, { getState, dispatch }) =>
    api
      .getMyList(fetchParams(getState, slice, sliver))
      .then((data) => dispatchListItemsNextAction({ data, idName, dispatch, nextAction }));

export default payloadCreatorMyListWithFetch;
